<template>
  <div id="ServiceNotes">
    <!--Title-->
    <div class="row">
      <h4 class="col-xs-12 card-title csp-card-title">Any Notes for Us?</h4>
    </div>
    <!--Text-->
    <div class="row">
      <div class="col-xs-12 ">
        <p class="card-text csp-banner-text">If you have any notes for us or our team or if you’d like us to reach out to you, please let us know below. Once you’re finished, just press “Submit” and that’s all you need to do!</p>
      </div>                
    </div>
    
    <div class="row">
      <div class="col-xs-12">
        <form>
          
          <div class="md-form">
            <textarea type="text" id="csp-notes" class="md-textarea" v-model.lazy="notes"></textarea>
            <label for="csp-notes" v-bind:class="{ active: notes }">Notes</label>
          </div>
          
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Notes',
    computed: {
      notes: {
        get: function () {
          return this.$store.getters.notes
        },
        set: function (newValue) {
          this.$store.commit('updateNotes', newValue)
        }
      }
    }
  }
</script>

<style scoped>
  

  /* All Mobile Sizes (devices and browser) */
  @media only screen and (max-width: 767px) {



  }
  
  @media only screen and (min-width: 480px) and (max-width: 767px) {

  }
  
  
  @media only screen and (max-width: 479px) {

  }
</style>



// WEBPACK FOOTER //
// ServiceNotes.vue?5fa06dc6